import React from "react";
import { FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import Logo from "../../assets/images/bridgetune-logo.png";
import { useNavigate } from "react-router-dom";
import { ExploreIcon } from "../../assets/images/svgExports";
import Button from "../library/button";

type FooterCTACardProps = {
  data?: Record<string, any>;
};

const Footer: React.FC<FooterCTACardProps> = ({ data }) => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("");

  const LinkedIn = FaLinkedinIn as React.ComponentType<{
    size?: string;
  }>;
  const Instagram = FaInstagram as React.ComponentType<{
    size?: string;
  }>;

  const Whatsapp = FaWhatsapp as React.ComponentType<{
    size?: string;
  }>;
  const solutionsLinks = [
    { name: "Consumers Engagement", href: "/solutions#consumer-engagement" },
    { name: "Revenue Intelligence", href: "/solutions#revenue-intelligence" },
    { name: "Loyalty & Retention", href: "/solutions#loyalty-retention" },
    { name: "Platform Features", href: "/platform" },
    { name: "Industries We Serve", href: "/industries" },
  ];

  const companyLinks = [
    { name: "About us", href: "/about-us" },
    { name: "Case Studies", href: "/success-stories" },
    { name: "Careers", href: "/careers" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (data?.showInput && data.onSubmit) {
      data.onSubmit(value);
      return;
    }

    if (data?.buttonRoute) {
      navigate(data.buttonRoute);
    }
  };
  return (
    <footer
      className={`bg-[#111827] text-white px-6 lg:px-10 md:px-[5%] pb-12 relative rounded-t-[24px] ${
        data && "mt-36"
      }`}
    >
      {data && (
        <div className="z-10 absolute top-[-150px] w-full flex justify-center left-0">
          <div className="bg-[#2C73DB] rounded-[40px] lg:rounded-[60px] px-6 md:px-16 py-14 text-center text-white shadow-xl w-[85%]">
            <h2 className="text-2xl md:text-4xl font-[100] mb-4">
              {data.headerText}
            </h2>

            <p className="text-sm md:text-base font-light max-w-xl mx-auto mb-8">
              {data.bodyText}
            </p>

            <form
              onSubmit={handleSubmit}
              className={`flex flex-col sm:flex-row gap-4 justify-center items-center`}
            >
              {data.showInput && (
                <input
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder={"Enter Email"}
                  className="w-full sm:w-72 px-4 py-3 rounded-full text-sm text-gray-900 outline-none"
                  required
                />
              )}

              <Button
                type="submit"
                className="bg-white gap-2 text-[#2C73DB] px-8 py-3 rounded-full font-medium text-sm hover:opacity-90 transition w-full md:w-[max-content]"
              >
                {data.buttonText || "Get Started"} <ExploreIcon />
              </Button>
            </form>
          </div>
        </div>
      )}
      <div
        className={`max-w-7xl mx-auto  ${data ? "pt-64 lg:pt-44" : "pt-12"}`}
      >
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-20 lg:gap-32 lg:px-10">
          <div className="md:w-1/3">
            <div
              className="w-36 cursor-pointer mb-6"
              onClick={() => navigate("/")}
            >
              <img src={Logo} alt="bridgetune logo" className="w-full" />
            </div>

            <p className="text-sm mb-6 font-light">
              Powering customer engagement, loyalty, and retention across
              Africa. We blend technology with entertainment to help brands turn
              customers into lifelong fans.
            </p>

            <p className="text-sm font-light mb-6">
              Licensed VAS Provider • Telecom Ecosystem Partner
            </p>

            <div className="flex space-x-4 text-white">
              <a
                href="https://www.instagram.com/bridgetunes_?igsh=MWEzNGpncjV6d2tneQ=="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <Instagram size="20" />
              </a>

              <a
                href="https://www.linkedin.com/company/bridgetune/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <Whatsapp size="20" />
              </a>

              <a
                href="https://www.linkedin.com/company/bridgetune/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <LinkedIn size="20" />
              </a>
            </div>
          </div>

          <div className="flex-1 md:w-1/3">
            <h4 className="text-[#1E88E5] font-semibold text-base mb-4">
              Solutions
            </h4>
            <ul className="space-y-5 text-sm text-white">
              {solutionsLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="hover:text-[#2C73DB] transition-colors duration-200 font-light"
                    onClick={() => navigate(link.href)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 md:w-1/3">
            <h4 className="text-[#1E88E5] font-semibold text-base mb-4">
              Company
            </h4>
            <ul className="space-y-5 text-sm text-white">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="hover:text-[#2C73DB] transition-colors duration-200 font-light"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <hr className="border-t border-gray-700 mt-12 mb-6" />

        <div className="flex flex-col md:flex-row justify-between items-start text-xs gap-4">
          <p className="text-center md:text-left">
            Copyright© 2025 Bridgetune. All rights reserved.
          </p>
          <ul className="flex space-x-6">
            <li>
              <a
                href="#!"
                className="hover:text-[#ffffff99] text-white transition-colors duration-200"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="#!"
                className="hover:text-[#ffffff99] text-white transition-colors duration-200"
              >
                Terms of Service
              </a>
            </li>
            <li>
              <a
                href="#!"
                className="hover:text-[#ffffff99] text-white transition-colors duration-200"
              >
                Cookies Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
